import Indicador from "..";
import DCEditFields from "./components/DCEditFields";
import { DCParamFields } from "./components/DCParamFields";
import dcReport from "./reports";
import dcReportSummary from "./reports/summary";
import _ from "lodash"

export default class DC extends Indicador {
    static get fullName() {
        return "Distância do Corte";
    }

    static get abbrev() {
        return "DC";
    }

    // static get multTipo() {
    //     return true
    // }

    static get legacyApontamentoMap() {
        return {
            dataHoraDC: {
                newField: "date",
                convert: this.parseLegacyDate,
            },

            tipo: "tipo",
            talhao: "talhao",
            trator: "trator",
            implemento: "implemento",
            frente: "frente",
            turno: "turno",

            coletasDC: {
                type: Array,
                newField: "coletas",
                children: {
                    espacamentoDC: "espacamento",
                    conforme: "conforme",
                    descricaoColetaDC: "observacao",
                    foto: {
                        newField: "image.uid",
                        convert: this.convertLegacyImageUid,
                    },
                    confirmaRelatorio: "confirmaRelatorio",
                    "foto.georeferencia": "georeferencia",
                    georeferencia: "georeferencia",
                },
            },

            conformidadeAmostra: "conformidade",

            observacaoAmostraDC: "observacao",

            itensColetaDC: "images",
        };
    }

    static get legacyParamMap() {
        return {
            disCorteIntervaloMinimoManual: "manual.intervaloMin",
            disCorteIntervaloMaximoManual: "manual.intervaloMax",
            percentualConformidadeManual: "manual.meta",

            disCorteIntervaloMinimoMecanizado: "mecanizado.intervaloMin",
            disCorteIntervaloMaximoMecanizado: "mecanizado.intervaloMax",
            percentualConformidadeMecanizado: "mecanizado.meta",
        };
    }

    getAverage(visita, field, tipoName, params) { // pdf da visita ou pdf do laudo
        const apontamentos = visita.getApontamentosByIndicador(this, tipoName)

        if (!_.isEmpty(apontamentos)) {
            if (field === "conformidade") {
                let qtdConforme = 0
                let qtdNaoConforme = 0

                apontamentos.forEach(apontamento => {
                    for (const coleta of apontamento.coletas) {
                        if (coleta.conforme === "Sim") {
                            qtdConforme++
                        } else {
                            qtdNaoConforme++
                        }
                    }
                })

                return (qtdConforme * 100) / (qtdConforme + qtdNaoConforme)
            } else if (field === "arrowNaoConforme") {
                let numAcima = 0, numAbaixo = 0
                let sumAcima = 0, sumAbaixo = 0
                let avgAcima = 0, avgAbaixo = 0
                let percentAcima = 0, percentAbaixo = 0
                let numConforme = 0
                let obj

                for (let i = 0; i < apontamentos.length; i++) {
                    // cálculo já foi feito no cadastro do apontamento
                    if (
                        apontamentos[i].hasOwnProperty('sumAbaixo')
                        && apontamentos[i].hasOwnProperty('sumAcima')
                        && apontamentos[i].hasOwnProperty('qtdAbaixo')
                        && apontamentos[i].hasOwnProperty('qtdAcima')
                    ) {
                        numAcima += apontamentos[i].qtdAcima
                        numAbaixo += apontamentos[i].qtdAbaixo
                        sumAcima += apontamentos[i].sumAcima
                        sumAbaixo += apontamentos[i].sumAbaixo
                        numConforme += apontamentos[i].qtdConforme
                    } else {
                        const f = parseFloat
                        let qtdAcima = 0
                        let qtdAbaixo = 0
                        let sumEspacamentoAcima = 0
                        let sumEspacamentoAbaixo = 0

                        for (let j = 0; j < apontamentos[i].coletas.length; j++) {
                            if (apontamentos[i].coletas[j].conforme === "Não") {
                                const espacamento = f(apontamentos[i].coletas[j].espacamento)
                                if (espacamento < f(params.intervaloMin)) {
                                    qtdAbaixo++
                                    sumEspacamentoAbaixo += espacamento
                                } else if (espacamento > f(params.intervaloMax)) {
                                    qtdAcima++
                                    sumEspacamentoAcima += espacamento
                                }
                            } else if (apontamentos[i].coletas[j].conforme === "Sim") {
                                numConforme++
                            }
                        }

                        if (qtdAcima > 0) {
                            numAcima += qtdAcima
                            sumAcima += sumEspacamentoAcima
                        }
                        if (qtdAbaixo > 0) {
                            numAbaixo += qtdAbaixo
                            sumAbaixo += sumEspacamentoAbaixo
                        }
                    }
                }

                if (numAcima > 0) {
                    percentAcima = (numAcima * 100) / (numConforme + numAcima + numAbaixo)
                    avgAcima = ((sumAcima / numAcima).toFixed(3))
                } else { avgAcima = 0 }

                if (numAbaixo > 0) {
                    percentAbaixo = (numAbaixo * 100) / (numConforme + numAcima + numAbaixo)
                    avgAbaixo = (((sumAbaixo / numAbaixo)).toFixed(3))
                } else { avgAbaixo = 0 }

                obj = {
                    result: "igual",
                    acima: avgAcima,
                    abaixo: avgAbaixo,
                    qtdAcima: numAcima,
                    qtdAbaixo: numAbaixo,
                    sumAcima: sumAcima,
                    sumAbaixo: sumAbaixo,
                    percentAcima: percentAcima,
                    percentAbaixo: percentAbaixo,
                }
                return obj
            }
        }
    }

    static paramFields(tipoIndicadorField = '') {
        return <DCParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <DCEditFields visita={visita} TipoClass={TipoClass} />
    }

    async renderReport(visita) {
        return dcReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return dcReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0;
        }

        let conformeCount = 0;
        const total = apontamento.coletas.length;

        let qtdAcima = 0 // nº de coletas acima da meta
        let sumAcima = 0 // soma das coletas acima da meta

        let qtdAbaixo = 0 // nº de coletas abaixo da meta
        let sumAbaixo = 0 // soma das coletas abaixo da meta

        for (const coleta of apontamento.coletas) {
            if (f(coleta.espacamento) >= f(params.intervaloMin) && f(coleta.espacamento) <= f(params.intervaloMax)) {
                coleta.conforme = "Sim";
                coleta.acima = 0
                coleta.abaixo = 0
                conformeCount++;
            } else {
                coleta.conforme = "Não"
                if (f(coleta.espacamento) > f(params.intervaloMax)) { // acima
                    coleta.acima = 1
                    coleta.abaixo = 0
                    qtdAcima++
                    sumAcima += f(coleta.espacamento)
                } else if (f(coleta.espacamento) < f(params.intervaloMin)) { // abaixo
                    coleta.acima = 0
                    coleta.abaixo = 1
                    qtdAbaixo++
                    sumAbaixo += f(coleta.espacamento)
                }
            }
        }

        apontamento.qtdAcima = qtdAcima
        if (qtdAcima > 0) { // nao da pra fazer divisao por zero
            apontamento.percentAcima = (qtdAcima * 100) / (conformeCount + qtdAcima + qtdAbaixo)
            apontamento.mediaAcima = (sumAcima / qtdAcima) // média das coletas acima da meta
            apontamento.sumAcima = sumAcima
        } else { apontamento.mediaAcima = 0 }

        apontamento.qtdAbaixo = qtdAbaixo
        if (qtdAbaixo > 0) { // nao da pra fazer divisao por zero
            apontamento.percentAbaixo = (qtdAbaixo * 100) / (conformeCount + qtdAcima + qtdAbaixo)
            apontamento.mediaAbaixo = (sumAbaixo / qtdAbaixo) // média das coletas abaixo da meta
            apontamento.sumAbaixo = sumAbaixo
        } else { apontamento.mediaAbaixo = 0 }

        apontamento.qtdConforme = conformeCount

        return ((100 * conformeCount) / total).toFixed(2);
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatus(conformidade, meta, 88.37, 100, 110.46);
    }
    static calcPontosAmostrados(apontamento, paramItems) {
        const result = [];

        for (const item of paramItems) {
            let count = 0;

            for (const coleta of apontamento.coletas) {
                if (this.calcPontoAmostradoColeta(item, coleta.espacamento)) {
                    count++;
                }
            }

            result.push({
                ...item,
                count: count,
            });
        }

        return result;
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },

            { title: "Talhão", field: "talhao.nome" },

            { title: "Frota", field: "trator.numeroFrotaTrator", width: 'auto' },
            { title: "Frente", field: "frente", width: 'auto' },
            { title: "Implemento", field: "implemento.nomeImplemento", width: 'auto' },

            {
                title: "Espaçamento", width: 'auto', getValue: (a) => {
                    let sum = 0
                    let arr = a.coletas.map(x => {
                        if (x.espacamento) {
                            sum = sum + parseFloat(x.espacamento)
                            return x.espacamento
                        } else {
                            return 0
                        }

                    })
                    if (sum) {
                        return (sum / arr.length).toFixed(2)
                    } else {
                        return '0'
                    }
                }
            },

            {
                title: "Conf.(%)", field: "conformidade", width: 38, getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta))
                }
            },
        ]
    }

    static getResultStr(apontamento) {
        let sum = 0
        let media = 0
        let arr = apontamento.coletas?.map(x => {
            if (x.espacamento) {
                sum = sum + parseFloat(x.espacamento)
                return x.espacamento
            } else {
                return 0
            }

        })
        if (sum) {
            media = (sum / arr.length).toFixed(2)
        } else {
            media = '0'
        }

        return "Espaçamento: " + media
    }
}
